import { BaseSelectField } from "../components/BaseSelectField/BaseSelectField";
import IsNullOrEmpty from "../components/IsNullOrEmpty";
import { Fragment, useEffect, useState } from "react";
import GetFetch from '../hooks/GetFetch';

const FiscalYearSelectDropdown = (
    {
        enableSearch,
        inputAttribute,
        label,
        onEnterKeyDown,
        optionUpdatedByUser,
        value,
        isVisible
    }
) => {
    const [fiscalYearsList, setFiscalYearsList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errorText, setErrorText] = useState('');

    const fetchFiscalYears = async () => {
        setLoading(true);
        const result = await GetFetch('/v1/BillPeriod');
        const { Success, Message, Errors } = result;

        if (Success) {
            setFiscalYearsList(Message);
        }
        else {
            setErrorText('Error loading data. Please try again.');
        }

        setLoading(false);
    };

    useEffect(() => { fetchFiscalYears(); }, []);

    const fiscalYears = fiscalYearsList.map(({FiscalYear}) => FiscalYear);

    return (
        <Fragment>
            <BaseSelectField
                data={fiscalYears}
                enableSearch={enableSearch}
                errorText={errorText}
                inputAttribute={inputAttribute}
                label={label}
                onEnterKeyDown={onEnterKeyDown}
                onOptionChanged={(e) => e.component.validate()}
                optionUpdatedByUser={optionUpdatedByUser}
                validationRuleCallback={() => !IsNullOrEmpty(value)}
                value={value}
                isVisible={isVisible}
            />
        </Fragment>
    );
};

export default FiscalYearSelectDropdown;